var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../../core/components/Button';
import useUser from '../../../core/hooks/useUser';
import { isCoach } from '../../../helpers/permissions';
import withSDK from '../../../core/hocs/withSDK';
import CommunityInfo from '../../../social/components/CommunityInfo';
import Post from '../../../social/components/post/Post';
import { useConfig } from '../../../social/providers/ConfigProvider';
import { Wrapper, NavButtonGroup } from './styles';
const CommunityPost = ({ currentUserId, postId, commentId, communityId, readonly, handleCopyPostPath, handleCopyCommentPath, }) => {
    const { fetchNextPostInCommunity } = useConfig();
    const { user: currentUser } = useUser(currentUserId, [currentUserId]);
    const [olderButtonDisabled, setOlderButtonDisabled] = useState(false);
    const [newerButtonDisabled, setNewerButtonDisabled] = useState(false);
    const navigate = useNavigate();
    const onOlderPost = (communityId, postId) => __awaiter(void 0, void 0, void 0, function* () {
        const nextPostPath = yield fetchNextPostInCommunity(communityId, postId, "BEFORE");
        if (nextPostPath) {
            navigate(nextPostPath);
            setNewerButtonDisabled(false);
        }
        else {
            setOlderButtonDisabled(true);
        }
    });
    const onNewerPost = () => __awaiter(void 0, void 0, void 0, function* () {
        const nextPostPath = yield fetchNextPostInCommunity(communityId, postId, "AFTER");
        if (nextPostPath) {
            navigate(nextPostPath);
            setOlderButtonDisabled(false);
        }
        else {
            setNewerButtonDisabled(true);
        }
    });
    return (React.createElement(Wrapper, null,
        React.createElement(CommunityInfo, { communityId: communityId }),
        isCoach(currentUser) &&
            React.createElement(NavButtonGroup, { isFullWidth: true },
                React.createElement(PrimaryButton, { disabled: olderButtonDisabled, onClick: () => onOlderPost(communityId, postId) }, "< Older"),
                React.createElement(PrimaryButton, { disabled: newerButtonDisabled, onClick: () => onNewerPost(communityId, postId) }, "Newer >")),
        React.createElement(Post, { key: postId, postId: postId, hidePostTarget: false, readonly: readonly, handleCopyPostPath: handleCopyPostPath, handleCopyCommentPath: handleCopyCommentPath })));
};
CommunityPost.propTypes = {
    commentId: PropTypes.string,
    postId: PropTypes.string.isRequired,
    communityId: PropTypes.string.isRequired,
    currentUserId: PropTypes.string.isRequired,
    readonly: PropTypes.bool,
    handleCopyPostPath: PropTypes.func,
    handleCopyCommentPath: PropTypes.func,
};
export default withSDK(CommunityPost);
//# sourceMappingURL=index.js.map